<template>
  <div class="tree-node-wrap">
    <div class="tree-node-chip" :class="{ 'tree-node-chip--experiment': isExperimentNode }">{{ nodeLabel }}</div>

    <div v-if="childNodeIds.length" class="tree-children-section">
      <div class="tree-connector"></div>
      <div class="tree-children-grid">
        <StructureRuleTreeNode
          v-for="childId in childNodeIds"
          :key="`child-${nodeId}-${childId}`"
          :node-id="childId"
          :type-map="typeMap"
          :children-by-parent="childrenByParent"
          :path-ids="nextPathIds"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StructureRuleTreeNode',
  props: {
    nodeId: {
      type: [Number, String],
      required: true,
    },
    typeMap: {
      type: Object,
      required: true,
    },
    childrenByParent: {
      type: Object,
      required: true,
    },
    pathIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    nodeLabel() {
      return this.typeMap[this.nodeId] || String(this.nodeId);
    },

    isExperimentNode() {
      return this.nodeId === 'EXPERIMENTS';
    },

    nextPathIds() {
      return [...this.pathIds, this.nodeId];
    },

    childNodeIds() {
      const rawChildren = this.childrenByParent[this.nodeId] || [];
      const seen = new Set();
      const uniqueChildren = [];

      for (const childId of rawChildren) {
        if (!childId || seen.has(childId)) {
          continue;
        }
        seen.add(childId);
        uniqueChildren.push(childId);
      }

      return uniqueChildren.filter((childId) => !this.nextPathIds.includes(childId));
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/variables.scss';

.tree-node-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 180px;
}

.tree-node-chip {
  background: white;
  border: 1px solid rgba($primary-color, 0.28);
  color: $primary-color;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  text-align: center;
  min-width: 140px;

  &--experiment {
    background: lighten(#cdfae1, 4%);
    border-color: rgba($primary-color, 0.22);
    font-style: italic;
    font-weight: 500;
  }
}

.tree-children-section {
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tree-connector {
  width: 2px;
  height: 14px;
  background: rgba($primary-color, 0.35);
}

.tree-children-grid {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
